import { makeStyles, tokens } from "@fluentui/react-components";
/**
 * Styles for the WelcomeBanner component
 */ export const useWelcomeBannerStyles = makeStyles({
    root: {
        minHeight: "48px",
        backgroundColor: tokens.colorNeutralBackground1,
        borderRadius: tokens.borderRadiusMedium,
        margin: tokens.spacingVerticalM,
        padding: `${tokens.spacingVerticalM} ${tokens.spacingHorizontalM}`,
        boxShadow: tokens.shadow8,
        border: `1px solid ${tokens.colorNeutralStroke2}`,
        alignItems: "center",
        display: "flex",
        flexWrap: "wrap",
        gap: tokens.spacingHorizontalS
    },
    // Overlay positioning for Teams tabs
    tabViewOverlay: {
        position: "fixed",
        top: "0",
        left: "0",
        right: "0",
        zIndex: 1000,
        borderRadius: "0",
        margin: "0"
    },
    content: {
        flex: "1 1 0%",
        textAlign: "center",
        minWidth: "200px",
        wordWrap: "break-word",
        overflowWrap: "break-word"
    },
    text: {
        color: tokens.colorNeutralForeground1,
        fontSize: tokens.fontSizeBase300,
        lineHeight: tokens.lineHeightBase300,
        wordWrap: "break-word",
        overflowWrap: "break-word",
        hyphens: "auto"
    },
    link: {
        color: tokens.colorBrandForegroundLink,
        textDecorationLine: "none",
        fontWeight: tokens.fontWeightSemibold,
        "&:hover": {
            color: tokens.colorBrandForegroundLinkHover
        },
        "&:active": {
            color: tokens.colorBrandForegroundLinkPressed
        }
    },
    dismissButton: {
        color: tokens.colorNeutralForeground2,
        backgroundColor: "transparent",
        marginLeft: tokens.spacingHorizontalS,
        flexShrink: 0,
        alignSelf: "flex-start",
        "&:hover": {
            backgroundColor: tokens.colorNeutralBackground1Hover
        }
    }
});
